module.exports = __webpack_public_path__ + "img/alipay_tig.00b07799.png";